import React from 'react';
import { AppointmentCard } from '../../AppointmentCard';
import { View } from '../../View';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet } from '../../../hooks';
export const AppointmentBlock = ({ onPress, isLoading, data }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: styles.container }, isLoading ? (React.createElement(AppointmentCard, { isLoading: true, compact: true })) : (React.createElement(AppointmentCard, { compact: true, duration: data.duration, participants: data.participants.map((v) => v.name), status: data.status, participantStatus: data.participantStatus, subject: data.subject, time: data.time, onPress: () => {
            onPress(data.id);
        } }))));
};
const getStyles = createStyleSheet(({ size }) => ({
    container: {
        maxWidth: 275,
        marginVertical: size.B
    }
}));
//# sourceMappingURL=AppointmentBlock.js.map